export default "__VITE_ASSET__CEDQ5dpX__"